/* eslint-disable max-classes-per-file */
import BlockComponentButton from '../../../../models/BlockComponentValues/BlockComponentButton';
import BlockComponentImage from '../../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../../models/BlockComponentValues/BlockComponentText';
import { ColorPickerColors } from '../../../../models/ColorPicker';
import LinkData from '../../../../models/LinkData';
import ImageSettings from '../../../../models/BlockComponentSettings/ImageSettings';

class BlockHeaderWithLogoData {
  logo?: BlockComponentImage;
  menus?: LinkData[];
  contact?: BlockComponentText;
  contactInfo?: BlockComponentText;
  leftButton?: BlockComponentButton;
  rightButton?: BlockComponentButton;
  url?: BlockComponentImage;
  isFree?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockHeaderWithLogoData {
  export function make(isFree?: boolean, logo?: string, menus?: LinkData[], contact?: string, contactInfo?: string, leftButton?: BlockComponentButton, rightButton?: BlockComponentButton, url?: string): BlockHeaderWithLogoData {
    return {
      isFree,
      logo: BlockComponentImage.make(logo, ImageSettings.getDefault(1, { x: 0, y: 0 }, { width: 100, height: 100 }, { width: 533, height: 300 })),
      menus,
      contact: contact ? BlockComponentText.make(contact) : undefined,
      contactInfo: contactInfo ? BlockComponentText.make(contactInfo) : undefined,
      leftButton,
      rightButton,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(isFree = false, logo = ''): BlockHeaderWithLogoData {
    return make(
      isFree,
      logo,
      [
        LinkData.getDefault('メニュー1'),
        LinkData.getDefault('メニュー2'),
        LinkData.getDefault('メニュー3'),
      ],
      '株式会社〇〇',
      '0120-XXX-XXXX',
      BlockComponentButton.getDefault(undefined, ColorPickerColors.LIGHT_BLUE),
      BlockComponentButton.getDefault(undefined, ColorPickerColors.ORANGE),
    );
  }
}

export default BlockHeaderWithLogoData;
